import React from "react";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import CalcForm from "@/components/sections/CalcForm";
import Reviews from "@/components/sections/Reviews";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

const HomePage = () => (
  <div className="App font-body text-[#111111]" data-testid="sanvioro-app">
    <Header />
    <main>
      <Hero />
      <Services />
      {/* CalcForm uses its own py-20 md:py-28 shell — trim the bottom so
          the next section (Process) flows in tighter, matches the spacing
          rhythm we use on /uklid-bytovych-domu-brno. */}
      <div className="-mb-12 md:-mb-16">
        <CalcForm />
      </div>
      <Process />
      <Reviews />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default HomePage;
